import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M9 12.5C9 13.05 9.45 13.5 10 13.5H14C14.55 13.5 15 13.05 15 12.5C15 11.95 14.55 11.5 14 11.5H10C9.45 11.5 9 11.95 9 12.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.0002 3.5H7.00018C6.69018 3.5 6.39019 3.65 6.20019 3.9L3.20019 7.9C3.19368 7.90918 3.18733 7.91843 3.18113 7.92776C3.06709 8.09016 3 8.28763 3 8.5V20.5C3 21.05 3.45 21.5 4 21.5H20C20.55 21.5 21 21.05 21 20.5V8.5C21 8.43796 20.9943 8.3772 20.9833 8.31821C20.9568 8.16842 20.8958 8.02471 20.8002 7.9L17.8002 3.9C17.6102 3.65 17.3102 3.5 17.0002 3.5ZM18.0002 7.5L16.5002 5.5H13V7.5H18.0002ZM11 7.5V5.5H7.50018L6.00018 7.5H11ZM5 9.5H19V19.5H5V9.5Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}